import $ from "jquery";
import state from "../../../core/offsetState";

export const urgentNewsSpacerHeight = () => {
    const urgentNews = $('.urgent-news');

    if (urgentNews.length === 0) {
        return;
    }

    state.changeUrgentNewsHeight(urgentNews.height());
    $('.urgent-news-spacer').css('height', urgentNews.height());
};
